// const currentOrigin = `http://192.168.1.254:5000/`;
const currentOrigin = window.location.origin + '/';

const API_BASE_URL = currentOrigin + 'api';

export const fetchData = async (url: string, accessToken: string): Promise<any> => {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // console.warn(response);

    if (!response.ok) {
      const errorData = await response.json(); // Ambil pesan dari API jika ada
      throw new Error(errorData.message || 'Request failed');
    }

    return {
      success: true,
      data: await response.json(),
    };
  } catch (error) {
    console.error('Error fetching data:', error.message);
    return {
      success: false,
      message: error.response ? error.response.message : error.message,
    };
  }
};

export const postData = async (url: string, data: any, accessToken: string): Promise<any> => {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        // Tambahkan headers lain jika diperlukan
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json(); // Ambil pesan dari API jika ada
      throw new Error(errorData.message || 'Request failed');
    }

    return {
      success: true,
      data: await response.json(),
    };
  } catch (error) {
    return {
      success: false,
      message: error.response ? error.response.message : error.message,
    };
  }
};
export const deleteData = async (url: string, data: any, accessToken: string): Promise<any> => {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        // Tambahkan headers lain jika diperlukan
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json(); // Ambil pesan dari API jika ada
      throw new Error(errorData.message || 'Request failed');
    }

    return {
      success: true,
      data: await response.json(),
    };
  } catch (error) {
    return {
      success: false,
      message: error.response ? error.response.message : error.message,
    };
  }
};
